export default "__VITE_ASSET__CTTJdUoQ__"